module.exports = __webpack_public_path__ + "img/1.12f604b7.png";